import IRequireAuthentication from '../interfaces/IRequireAuthentication';

const requireAuthentication = (): IRequireAuthentication => ({
  callback: null,
  isCallbackValid: null,
});

export default requireAuthentication;
